import React from "react";

const steps = [
  { id: 1, label: "CONTACTO" },
  { id: 2, label: "USO" },
  { id: 3, label: "EVIDENCIA" },
  { id: 4, label: "FINAL" },
];

const Stepper = ({ currentStep, onStepClick }) => {
  return (
    <div className="overflow-x-auto py-4 bg-dark-gray">
      <div className="flex items-center justify-start gap-4 min-w-max px-4">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Step Button */}
            <button
              onClick={() => onStepClick(step.id)}
              className="flex flex-col items-center flex-shrink-0 focus:outline-none group"
              aria-label={`Go to step: ${step.label}`}
              aria-current={currentStep === step.id ? "step" : undefined}
            >
              <span
                className={`text-xl sm:text-2xl font-bold ${
                  currentStep === step.id
                    ? "text-green-500"
                    : "text-white group-hover:text-green-400"
                } transition-colors duration-200`}
              >
                {step.id}
              </span>
              <span
                className={`text-[10px] sm:text-xs font-bold mt-1 ${
                  currentStep === step.id
                    ? "text-green-500 border-b-2 border-green-500"
                    : "text-white group-hover:text-green-400"
                } transition-colors duration-200`}
              >
                {step.label}
              </span>
            </button>

            {/* Divider (don't render after last step) */}
            {index < steps.length - 1 && (
              <div className="w-8 sm:w-14 h-0.5 bg-white opacity-60 mx-1 flex-shrink-0"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Stepper;